/**
 * Format a URL for display by removing protocol and truncating length
 *
 * Example:
 * formatURL("https://www.somedomain.com/collections/some-really-long-path")
 * // "somedomain.com/collections/some-really-lon..."
 */
const formatURL = (url: string, maxLength = 45) =>
  (url.length <= maxLength ? url : `${url.slice(0, maxLength - 3)}...`).replace(
    /https?:\/\/(www\.)?/,
    ""
  );

export { formatURL };
